import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=7a076cbc&"
import script from "./StandardTable.vue?vue&type=script&lang=js&"
export * from "./StandardTable.vue?vue&type=script&lang=js&"
import style0 from "./StandardTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports